import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxContainer", "selectedTags", "toggleIcon"]

  connect() {
    this.updateSelectedTags()
  }

  toggle() {
    const container = this.checkboxContainerTarget
    const icon = this.toggleIconTarget

    if (container.style.display === 'none') {
      container.style.display = 'flex'
      icon.textContent = '▲'
    } else {
      container.style.display = 'none'
      icon.textContent = '▼'
    }
  }

  updateSelectedTags() {
    const container = this.selectedTagsTarget
    const checkboxes = this.element.querySelectorAll('input[name="event_type_ids[]"]')

    container.innerHTML = ''

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const tag = document.createElement('span')
        tag.className = 'inline-flex items-center gap-2 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm'
        tag.innerHTML = `
          ${checkbox.dataset.name}
          <button type="button" data-action="click->event-type-filter#removeTag" data-event-type-id="${checkbox.value}" class="text-blue-600 hover:text-blue-800 font-bold">×</button>
        `
        container.appendChild(tag)
      }
    })
  }

  removeTag(event) {
    const eventTypeId = event.currentTarget.dataset.eventTypeId
    const checkbox = this.element.querySelector(`#event_type_${eventTypeId}`)

    if (checkbox) {
      checkbox.checked = false
      this.updateSelectedTags()
    }
  }
}
